import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Badge, Container } from "react-bootstrap";
import g34 from "../assets/images/bg34-1.png";
import logo from "../assets/images/logogf.png";
import qrcode from "../assets/images/qrcode.svg";
import shap from "../assets/images/shape1.png";
import otplogo from "../assets/images/otp-icon.png";
import "../assets/css/Login.css";
import { Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { InputOtp } from 'primereact/inputotp';
import { Button } from 'primereact/button';

const Otp = () => {
    const [value, setValue] = useState('');
    const [token, setTokens] = useState();
    return (
    <>
        <section className="useraccountDiv">
            <div class="fxt-shape">
                <div class="fxt-transformX-L-50 fxt-transition-delay-1">
                    <img src={shap} alt="shap"/>
                </div>
            </div>
            <Container>
                <Row className="mx-0 breadcrumb_part align-items-center">
                    <Col lg={8}>
                        <div className="fxt-column-wrap justify-content-center">
                            {/* <div className="fxt-animated-img">
                                <div className="fxt-transformX-L-50 fxt-transition-delay-10">
                                    <img src={g34} alt="productimg"/>
                                </div>
                            </div> */}
                            <div>
                                <div className="fxt-transformX-L-50 fxt-transition-delay-3">
                                    <Link to="/" className="logo me-5">
                                        <img src={logo} alt="Logo"  style={{height:'150px'}}/>
                                    </Link>
                                </div>
                                <div className="fxt-transformX-L-50 fxt-transition-delay-5">
                                    <div className="fxt-middle-content">
                                        <h1 className="fxt-main-title">Validate OTP</h1>
                                        <div className="fxt-switcher-description1">
                                        Please enter the OTP (one time password) to verify your account. A Code has been sent to *******@gmail.com
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="fxt-transformX-L-50 fxt-transition-delay-7">
                                <div className="fxt-qr-code">
                                    <img src={qrcode} alt="Logo"  style={{height:'130px'}}/>
                                </div>
                            </div> */}
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="prof_content user-dash">
                            <div className="fxt-otp-logo">
                                <img src={otplogo} alt="Logo"  style={{height:'80px'}}/>
                            </div>
                            <div className="d-flex flex-column gap-2 mb-2">
                                <label >Enter OTP Code Here</label>
                                <InputOtp value={token} onChange={(e) => setTokens(e.value)} integerOnly/>
                            </div>
                            
                            <Button
                                label="Verify"
                                className="py-2 w-100 d-block mt-4"
                                severity="warning"
                                style={{fontSize:'22px'}}
                            />
                            <p className="text-secondary mt-4">Not received your code? <Link to="/login" className="text-info">Resend code</Link></p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    </>
  );
};

export default Otp;